/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  AppCardListService,
  IAppCardListMethods,
  ILoadingMethods,
  LoadingService,
  StaticPageContentService,
  IStaticPageContentMethods,
  AddGroupService,
  IAddGroupMethods,
  CountryService,
  ICountryMethods,
} from "./components";

export type CreditUnionPageAgent = IStaticPageContentMethods &
  IHeaderMethods &
  ISettingsMethods &
  IAppCardListMethods &
  IAddGroupMethods &
  ILoadingMethods &
  IHeaderMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new AppCardListService(),
    new LoadingService(),
    new AddGroupService(),
    new CountryService(),
  ];
};

export const getAgent = () => {
  return createAgent<CreditUnionPageAgent>({
    plugins: getPlugins(),
  });
};
